var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockwallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 788,
    height: 789,
    viewBox: "0 0 788 789",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1266_227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.94 0.340332C176.37 0.340332 0 176.71 0 394.28C0 611.85 176.37 788.22 393.94 788.22C611.51 788.22 787.88 611.85 787.88 394.28C787.88 176.71 611.5 0.340332 393.94 0.340332ZM588.35 625.46L176.33 496.77L244.17 111.03L656.19 239.72L588.34 625.47L588.35 625.46Z",
    fill: "#327100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.92 198.68C18.89 256.31 0 323.09 0 394.28C0 399.23 0.09 404.16 0.28 409.07L77.37 331.39L117 152.23L51.93 198.68H51.92Z",
    fill: "url(#paint0_linear_1266_227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.387 475.35L81.5572 367.07L2.61719 437.18C17.1572 571.44 99.1572 685.47 214.027 744.67L327.147 636.14L209.257 506.98L176.627 496.79L180.397 475.36L180.387 475.35Z",
    fill: "url(#paint1_linear_1266_227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.113 531.33L210.513 507.72L91.2031 647.35C163.463 733.47 271.893 788.22 393.103 788.22C412.893 788.22 432.343 786.75 451.343 783.94L521.363 687.46L286.113 531.34V531.33Z",
    fill: "url(#paint2_linear_1266_227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.137 227.99L621.997 280.15L209.977 151.46L254.127 99.3003L666.137 227.99Z",
    fill: "#122600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.519 211.021L606.039 261.46L622.379 266.46L655.889 224.741L612.519 211.021Z",
    fill: "url(#paint3_linear_1266_227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.617 613.63L553.477 665.79L621.327 280.03L665.467 227.87L597.617 613.63Z",
    fill: "#54C900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.908 15.3201C724.798 81.3401 820.238 298.46 777.478 481.06C734.248 665.71 550.658 773.99 348.608 720.96C146.448 667.92 27.2882 477.89 58.4882 272.82C91.1982 57.9001 294.478 -40.3299 501.908 15.3201ZM600.188 615.41L668.038 229.66L256.018 100.98L188.168 486.73L600.188 615.42",
    fill: "url(#paint4_linear_1266_227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.418 735.86C417.848 735.86 383.508 731.43 349.188 722.42C299.518 709.38 253.918 687.92 213.678 658.61C174.698 630.23 141.748 595.27 115.728 554.71C63.2481 472.88 42.7281 372.68 57.9581 272.59C65.6481 222.06 82.9081 176.58 109.258 137.41L111.748 139.08C85.6481 177.88 68.5481 222.95 60.9281 273.04C45.8081 372.41 66.1681 471.87 118.258 553.09C144.068 593.34 176.768 628.03 215.448 656.19C255.388 685.27 300.638 706.58 349.948 719.52C462.468 749.05 575.268 729.03 659.418 664.6L661.238 666.98C602.038 712.31 528.788 735.86 451.418 735.86Z",
    fill: "url(#paint5_linear_1266_227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.153 617.11L594.243 616.07L661.633 232.91L252.133 105.01L253.923 99.2803L665.943 227.97C667.383 228.42 668.263 229.87 668.003 231.35L600.153 617.1V617.11Z",
    fill: "url(#paint6_linear_1266_227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.889 618.67L181.469 490.48L249.779 102.13L255.679 103.17L188.299 486.33L593.679 612.94L591.889 618.67Z",
    fill: "url(#paint7_linear_1266_227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.672 295.76L621.322 280.24L661.712 232.51L658.962 248.15L618.672 295.76Z",
    fill: "url(#paint8_linear_1266_227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.383 290.21L650.313 297.5L658.993 248.13L623.383 290.21Z",
    fill: "url(#paint9_linear_1266_227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.279 15.3203C467.739 6.06031 433.229 1.36031 399.539 0.820312C608.029 11.0003 773.939 183.26 773.939 394.28C773.939 489.56 740.109 576.93 683.819 645.06C729.149 603.63 762.259 547.66 777.849 481.07C820.609 298.46 725.169 81.3503 502.279 15.3303V15.3203Z",
    fill: "url(#paint10_linear_1266_227)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1266_227",
    x1: -9.49,
    y1: 208.51,
    x2: 90.13,
    y2: 314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#327100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3C7B06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5B9B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#73B42C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#85C637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8FD03E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#93D441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#91D23F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8ACB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7EBF33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#6EAE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#58981A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3E7E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#327100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1266_227",
    x1: 14.3272,
    y1: 446.77,
    x2: 261.337,
    y2: 662.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#4A8A10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#64A422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#79B92F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#87C839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#90D13F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#93D441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#91D23F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#8ACB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#7EBF33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6EAE28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#58981A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#3E7E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#327100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1266_227",
    x1: 171.203,
    y1: 571.83,
    x2: 450.293,
    y2: 782.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2D159",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#749B3C",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#3C581A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#1C3106",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#122600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#122700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#152E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#1A3A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#214B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#2B6100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#327100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1266_227",
    x1: 650.229,
    y1: 171.721,
    x2: 618.349,
    y2: 263.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53C200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1266_227",
    x1: 199.508,
    y1: 446.98,
    x2: 709.368,
    y2: 260.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53C200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1266_227",
    x1: 1.92809,
    y1: 186.14,
    x2: 568.998,
    y2: 814.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7FF00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8EBA00",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#476600",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#1E3500",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#122600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1A3000",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#3B5700",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#739A00",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7FF00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1266_227",
    x1: 511.543,
    y1: 308.96,
    x2: 361.963,
    y2: -101.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53C200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1266_227",
    x1: 232.839,
    y1: 550.62,
    x2: 515.809,
    y2: 264.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#43A000",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#45A103",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#49A307",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4EA70D",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#55AB15",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#5DB01E",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#67B72A",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#72BE37",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74BF39",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1266_227",
    x1: 678.332,
    y1: 235.81,
    x2: 537.702,
    y2: 340.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53C200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1266_227",
    x1: 648.793,
    y1: 237.84,
    x2: 635.543,
    y2: 299.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74BF39",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#558E27",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#2F5310",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#183003",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#122600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#162D02",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#28480C",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#46781E",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74BF39",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1266_227",
    x1: 594.389,
    y1: 200.88,
    x2: 621.179,
    y2: 587.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74BF39",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#6FBC34",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#63B426",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#59AE1A",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#51A910",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4BA509",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#46A204",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#43A000",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#43A000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#43A000",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#45A103",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#49A307",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4EA70D",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#55AB15",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5DB01E",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#67B72A",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74BF39",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1266_227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 787.87,
    height: 788.21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockwallet);
export default __webpack_public_path__ + "static/media/blockwallet.632b3027b303837ca5c80b390db886dd.svg";
export { ForwardRef as ReactComponent };